var _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitsBkg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 606,
    viewBox: "0 0 339 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M56.0967 357.951C25.6025 221.306 111.166 85.9253 247.203 55.5668C383.24 25.2084 518.243 111.366 548.737 248.011C579.231 384.656 493.668 520.036 357.631 550.395C221.594 580.753 86.5909 494.596 56.0967 357.951Z",
    stroke: "#ECB956"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.394,
    cy: 522.192,
    rx: 3.48456,
    ry: 3.5,
    transform: "rotate(167.42 176.394 522.192)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.483,
    cy: 489.983,
    rx: 6.47132,
    ry: 6.5,
    transform: "rotate(167.42 132.483 489.983)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.525,
    cy: 73.024,
    rx: 6.47132,
    ry: 6.5,
    transform: "rotate(167.42 196.525 73.024)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsBkg2);
export default __webpack_public_path__ + "static/media/benefits-bkg-2.74e618de4c50754149cd31d375c818a8.svg";
export { ForwardRef as ReactComponent };